import { FC } from 'react';

export type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** The meaning: Active, Shown, Online. The primitive does not know it. */
  label: string;
  /**
   * The accessible name when the visible label only names the state. Shown and
   * Hidden are fine on screen, but the switch should be announced by what it
   * controls ("Show 'Espresso' on the till").
   */
  ariaLabel?: string;
  disabled?: boolean;
  id?: string;
  /** Placement only. */
  className?: string;
};

/**
 * The one switch.
 *
 * Owns the track, thumb, checked/focus/disabled behaviour and the native
 * checkbox semantics (role="switch" so the state is announced as on/off). What
 * the switch *means* is the caller's business.
 */
const Switch: FC<SwitchProps> = ({ checked, onChange, label, ariaLabel, disabled = false, id, className }) => (
  <label className={['ui-switch', className].filter(Boolean).join(' ')}>
    <input
      id={id}
      type="checkbox"
      role="switch"
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel ?? label}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span className="ui-switch-track" aria-hidden="true">
      <span className="ui-switch-thumb" />
    </span>
    <span>{label}</span>
  </label>
);

export default Switch;
